import { CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Footer, ResponsiveAppBar } from "./layout";
import { LoginPage } from "./auth";
import { useAuthInfo } from "./common";
import { routes } from "./routes";
import { SafariPage } from "./layout/SafariPage";
import { Sidebar } from "./layout/sidenavbar";

// import { IdleDialog } from "./common/components/IdleDialog.component";

function App() {
  const decoded = useAuthInfo();

  const userAgentString = window.navigator.userAgent;

  // Detect Safari
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;
  let safariAgent = userAgentString.indexOf("Safari") > -1;
  let chromeMobileAgent = userAgentString.indexOf("CriOS") > -1;
  let edgeMobileAgent = userAgentString.indexOf("EdgiOS") > -1;

  // Discard Safari since it also matches Chrome
  if (chromeAgent && safariAgent) safariAgent = false;
  // Discard Safari since it also matches Chrome/Edge on iOS
  if (chromeMobileAgent && safariAgent) safariAgent = false;
  if (edgeMobileAgent && safariAgent) safariAgent = false;

  // alert(window.navigator.userAgent);

  return (
    <div>
      <CssBaseline />
      {!decoded && (
        <BrowserRouter>
          <Routes>
            {!safariAgent ? (
              <Route path="*" element={<LoginPage />} />
            ) : (
              <Route path="*" element={<SafariPage />} />
            )}
          </Routes>
        </BrowserRouter>
      )}
      {decoded && (
        <BrowserRouter>
          <ResponsiveAppBar />
          <Sidebar
            children={
              <Routes>
                {routes.map((item) =>
                  item.access.map(
                    (access, index) =>
                      access === decoded.role && (
                        <Route
                          path={item.path}
                          element={item.element}
                          key={index}
                        />
                      )
                  )
                )}
              </Routes>
            }
          />
          <Footer />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
